import React, { useState, useRef, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import { trackFormSubmit, trackFeatureUsage } from '../../../utils/googleAnalyticsService';

const ChatInput = ({ onSendMessage, disabled }) => {
  const [inputValue, setInputValue] = useState('');
  const textareaRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (inputValue?.trim() && !disabled && typeof onSendMessage === 'function') {
      // Track AI trip planning interaction
      trackFormSubmit('ai_chat_input', 'trip_planning', {
        message_length: inputValue?.length,
        has_prompt: inputValue?.trim()?.length > 0,
      });
      
      trackFeatureUsage('ai_trip_planner', 'send_message', {
        message_length: inputValue?.length,
      });
      
      onSendMessage(inputValue);
      setInputValue('');
    }
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter' && !e?.shiftKey) {
      e?.preventDefault();
      handleSubmit(e);
    }
  };

  const adjustTextareaHeight = () => {
    const textarea = textareaRef?.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = Math.min(textarea?.scrollHeight, 120) + 'px';
    }
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, [inputValue]);

  return (
    <div className="border-t border-border bg-background/95 backdrop-blur-sm">
      <div className="max-w-4xl mx-auto p-4">
        <form onSubmit={handleSubmit} className="flex items-end space-x-3">
          <div className="flex-1">
            <textarea
              ref={textareaRef}
              value={inputValue}
              onChange={(e) => setInputValue(e?.target?.value)}
              onKeyPress={handleKeyPress}
              placeholder="Ask me about state parks, activities, or trip planning..."
              disabled={disabled}
              className="w-full min-h-[44px] max-h-[120px] px-4 py-3 bg-input border border-border rounded-organic resize-none focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent transition-organic disabled:opacity-50 disabled:cursor-not-allowed"
              rows={1}
            />
          </div>
          <Button
            type="submit"
            variant="default"
            size="default"
            disabled={!inputValue?.trim() || disabled}
            loading={isLoading}
            iconName="Send"
            iconPosition="right"
            className="flex-shrink-0"
          >
            Send
          </Button>
        </form>
        
        <div className="flex items-center justify-between mt-2 text-xs text-muted-foreground">
          <span>Press Enter to send, Shift+Enter for new line</span>
          <span>{inputValue?.length}/2000</span>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;